import React, { ReactElement, useEffect, useState } from "react";
import styled from "styled-components";

interface LoadingProgressIndicatorProps {
  assetBase?: string;
  addSubscriberToLoadingStatus: (
    name: string,
    cb: (pctLoaded: number) => void
  ) => void;
}

const ProgressBarWrapper = styled.div`
  width: 33%;
  padding: 0;
  margin: 0;
`;

const Blackbackground = styled.div.attrs((props) => ({
  display: props.hidden ? "none" : "block",
}))`
  display: ${(props) => props.display};
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: black;
  width: 100%;
  height: 100%;
`;

const PresentedBy = styled.img`
  padding-bottom: 40px;
  width: 30%;
`;

function LoadingProgressIndicator(props: LoadingProgressIndicatorProps) {
  const { assetBase, addSubscriberToLoadingStatus } = props;

  const [progressPct, setProgressPct] = useState(0);
  const [showProgressBar, setShowProgressBar] = useState(false);

  useEffect(() => {
    addSubscriberToLoadingStatus(
      "loadingProgressIndicator",
      (pctLoaded: number) => {
        if (progressPct !== pctLoaded) {
          setProgressPct(pctLoaded);
        }
      }
    );
  }, [setProgressPct]);

  const showLoadingScreen = progressPct !== 100;

  const progressBar = (
    <progress
      style={{ width: "100%" }}
      id="loading"
      value={progressPct}
      max="100"
    >
      {progressPct}%
    </progress>
  );

  return showLoadingScreen ? (
    <Blackbackground>
      {assetBase !== undefined ? (
        <PresentedBy
          onLoad={() => setShowProgressBar(true)}
          src={`${assetBase}/images/loading-logo.png`}
        ></PresentedBy>
      ) : null}
      {showProgressBar ? (
        <ProgressBarWrapper>{progressBar}</ProgressBarWrapper>
      ) : null}
    </Blackbackground>
  ) : null;
}

export default LoadingProgressIndicator;
